export default "dist/images/block-button-grouped-1.87a3ead.png";